export default __webpack_public_path__ + "static/video-6216020ad9027f9a6789dd71807f8c76.mp4";